import { get } from '../api';

const getEmployerLandingPage = async (employerId) => {
  return await get(`/employers/${employerId}/public_landing_page`);
};

export default getEmployerLandingPage;
